import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import './_modal.scss';

class BlockerModal extends Component {
  render() {
    const { isShow, closeModal } = this.props;
    return (
      <div className="blocker-modal">
        <Modal className="blocker-modal-modal" show={isShow}>
          <div className="title">
            Pop up blocker detected!
            <br />
            In order to proceed to setup mandate, Kindly Turn Off / Disable your pop up blocker.
            <br />
            After that, kindly refresh the page again
          </div>
          <div className="custom-btn-box">
            <button className="custom-btn" onClick={closeModal}>
              OK
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default BlockerModal;
